import { MANIFEST_ICONS } from '../manifest/icons.js';
import { getSameKeyValueMapForManifest, manifestResolve } from './manifest.utils.js';
import { SwanAssetFolders } from '../types/enums.js';

const SWAN_ICON_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_ICONS);
function getSwanIconUrl(key, pathType, swanAssetBaseUrl) {
    return manifestResolve(MANIFEST_ICONS, key, SwanAssetFolders.ICONS, pathType, swanAssetBaseUrl);
}

export { SWAN_ICON_KEY_MAP, getSwanIconUrl };
